import $ from "jquery";

(function($) {
    $('a.section-gallery__item').colorbox({
        rel:'gal',
        transition: 'fade',
        current: '({current} / {total})',
        slideshow: false,
        maxHeight: '95%',
        maxWidth: '95%',
        title:function(){
            return $(this).attr('title');
        }
    });

})(jQuery);
